import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import Swal from 'sweetalert2';
import { AutoRefillService } from '../../../services/auto-refill.service';
import { SharedService } from '../../../services/shared.service';
import * as FileSaver from 'file-saver';
import { AUTO_REFILL_PHARMACY_OPTIONS } from './auto-refill.constants';
import {
  buildNursingHomeOptions,
  formatFileStamp,
  isScheduleUrgent,
  hasScheduleNote,
  pickDto
} from './auto-refill.utils';

@Component({
  selector: 'app-auto-refill-todo-tab',
  templateUrl: './auto-refill-todo-tab.component.html',
  styleUrls: ['./auto-refill.component.css']
})
export class AutoRefillTodoTabComponent implements OnInit, OnChanges {

  @Input() selectedPharmacyId = 0;
  @Output() selectedPharmacyIdChange = new EventEmitter<number>();
  @Output() checkRow = new EventEmitter<any>();
  @Output() error = new EventEmitter<string>();

  readonly pharmacyOptions = AUTO_REFILL_PHARMACY_OPTIONS;

  daysAhead = 7;
  nursingHomeFilter = 'All';
  nursingHomeOptions: string[] = ['All'];
  todoRows: any[] = [];
  todoLoading = false;
  todoLoaded = false;

  constructor(
    private autoRefillService: AutoRefillService,
    private sharedService: SharedService
  ) { }

  ngOnInit(): void {
    var self = this;
    this.sharedService.reloadUserPrivileges().then(function () {
      self.loadTodoList();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.selectedPharmacyId && !changes.selectedPharmacyId.firstChange) {
      this.nursingHomeFilter = 'All';
      this.loadTodoList();
    }
  }

  pick = pickDto;
  isUrgent = isScheduleUrgent;
  hasNote = hasScheduleNote;

  loadTodoList(): void {
    var userId = this.sharedService.getUserId();
    if (!userId || this.selectedPharmacyId <= 0) {
      return;
    }
    this.todoLoading = true;
    this.todoLoaded = false;
    var self = this;
    var nh = this.nursingHomeFilter === 'All' ? '' : this.nursingHomeFilter;
    this.autoRefillService.getTodoList(userId, this.selectedPharmacyId, this.daysAhead, nh).subscribe(
      function (data) {
        self.todoRows = data || [];
        self.todoLoading = false;
        self.todoLoaded = true;
        self.nursingHomeOptions = buildNursingHomeOptions(self.todoRows);
        if (self.todoRows.length === 0) {
          Swal.fire({
            icon: 'info',
            title: 'No pending refills',
            text: 'No pending refills for the next ' + self.daysAhead + ' days for this selection.',
            confirmButtonText: 'OK'
          });
        }
      },
      function () {
        self.todoLoading = false;
        self.todoLoaded = true;
        self.error.emit('Could not load the to-do list. Check database tables and Kroll connection.');
      }
    );
  }

  onPharmacyChange(): void {
    this.selectedPharmacyIdChange.emit(this.selectedPharmacyId);
    this.nursingHomeFilter = 'All';
    this.loadTodoList();
  }

  onDaysOrNhChange(): void {
    this.loadTodoList();
  }

  exportPdf(): void {
    var userId = this.sharedService.getUserId();
    if (!userId || this.selectedPharmacyId <= 0 || !this.todoRows || this.todoRows.length === 0) {
      return;
    }
    var self = this;
    var nh = this.nursingHomeFilter === 'All' ? '' : this.nursingHomeFilter;
    this.autoRefillService.exportTodoListPdf(userId, this.selectedPharmacyId, this.daysAhead, nh).subscribe(
      function (blob) {
        FileSaver.saveAs(blob, 'AutoRefills_' + formatFileStamp(new Date()) + '.pdf');
      },
      function () {
        self.error.emit('Could not generate PDF.');
      }
    );
  }

  onCheckRow(row: any): void {
    this.checkRow.emit(row);
  }
}
